import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { alert } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-bulk-edit-dialog',
    templateUrl: './bulk-edit-dialog.component.html',
    styleUrls: ['./bulk-edit-dialog.component.scss'],
    standalone: false
})
export class BulkEditDialogComponent implements OnInit {
    appInfo = inject(AppInformationService)
    result: Subject<any> = new Subject<any>();
    rowCount: number;
    bulkInfo: any ={};
    salesReps: any;
    processing = false;
    pricingTiers: any[];
    
    inactiveStatusOptions = [
    { text: 'Active', value: 'active' },
    { text: 'Inactive', value: 'inactive' }
  ];

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork) {}

    async ngOnInit() {
        this.pricingTiers = this.uow.lookups.pricingTiers;
        this.salesReps = await this.uow.getSalesReps();
    }

    statusChanged(e: any) {
        this.bulkInfo.inactiveStatus = e.addedItems[0];
    }

    async save() {
        this.processing = true;
        console.log('Bulk Edit Info:', this.bulkInfo);
        if (this.bulkInfo.salesRepId && this.bulkInfo.clearSalesRep) {
            await alert('You cannot set both Sales Rep and Clear Sales Rep at the same time.', this.appInfo.settings.company);
            this.processing = false;
            return;
        }
        if (this.bulkInfo.pastDue && this.bulkInfo.clearPastDue) {
            await alert('You cannot set both Past Due and Clear Past Due at the same time.', this.appInfo.settings.company);
            this.processing = false;
            return;
        }

        this.result.next({ success: true, value: this.bulkInfo });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}